import { useQuery } from '@tanstack/react-query';
import api from 'api';
import { getMixpanelErrorProps } from 'axiosUtils';
import useGetMixpanelProps from 'hooks/useGetMixpanelProps';
import { AgreementTemplate } from 'models/Agreement';
import { ErrorViewedProps } from 'models/MixpanelEvents';
import mixpanelService from 'services/mixpanelService';

export const AGREEMENT_TEMPLATE_QUERY_KEY = 'agreement-template';

export const getAgreementTemplateQueryKey = (listingId: string) => [
  AGREEMENT_TEMPLATE_QUERY_KEY,
  { listingId },
];

export default function useAgreementTemplateQuery(
  listingId: string,
  isEnabled = true,
) {
  const getMixpanelProps = useGetMixpanelProps();

  return useQuery<AgreementTemplate | null>({
    queryKey: getAgreementTemplateQueryKey(listingId),
    queryFn: async () => {
      const { data } = await api.agreements.getListingAgreement(listingId);

      return data;
    },
    onError: (error) =>
      mixpanelService.errorViewed(
        getMixpanelProps(getMixpanelErrorProps(error)) as ErrorViewedProps,
      ),
    enabled: !!listingId && isEnabled,
    staleTime: 0,
  });
}
